<script setup lang="ts">
import Token from '../global/Token.vue';
import Agent from '../global/Agent.vue';
</script>
<template>
  <Token>
    <Agent>
      <slot />
    </Agent>
  </Token>
</template>
